import { Field, Label } from "V2.0/common/fieldset";
import { EvalEvent, EvalEventLabels } from "../../types";
import { MultiListbox } from "V2.0/components/MultiListBox";

export default EvalRunConfigEventsToTrack;

const evalEventAsOptions = Object.values(EvalEvent).reduce(
  (acc, evalEvent, idx) => {
    acc.push({
      id: `${idx + 1}`,
      value: evalEvent,
      label: EvalEventLabels[evalEvent],
    });
    return acc;
  },
  [],
);

function EvalRunConfigEventsToTrack(props) {
  const { eventsToTrack, onEventsToTrackChange } = props;

  return (
    <Field>
      <Label>Events to Track</Label>
      <MultiListbox
        className="my-4"
        placeholder="No Events Tracked"
        options={evalEventAsOptions}
        value={eventsToTrack}
        onChange={onEventsToTrackChange}
      />
    </Field>
  );
}
